'use client';

import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '../ui/tooltip';
import { useTranslation } from 'react-i18next';
import { ReactNode } from 'react';

interface TooltipRedNotesProps {
  children: ReactNode;
  notesVisible: boolean;
}

export function TooltipRedNotes({
  children,
  notesVisible,
}: TooltipRedNotesProps) {
  const { t } = useTranslation();
  const tooltipKey = notesVisible
    ? 'tooltip.redNotes.hide'
    : 'tooltip.redNotes.show';

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>{children}</TooltipTrigger>
        <TooltipContent
          //   className='w-64'
          sideOffset={8}
          side='top'
          variant='zinc'
        >
          <div className='w-full m-2'>
            <div className='space-y-1'>
              <p className='text-sm'>{t(tooltipKey)}</p>
            </div>
          </div>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
